import { render, staticRenderFns } from "./Water-outage.vue?vue&type=template&id=a2cecd0a&scoped=true"
import script from "./Water-outage.vue?vue&type=script&lang=js"
export * from "./Water-outage.vue?vue&type=script&lang=js"
import style0 from "./Water-outage.vue?vue&type=style&index=0&id=a2cecd0a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2cecd0a",
  null
  
)

export default component.exports